
import React from "react";
import '../styles/NamedBuildingInfoScreen.css';

// @ts-check


/**
 * @param {{title: string, info: string, image: string, mirrored: ?boolean, narrow: ?boolean }} props 
 * @returns {JSX.Element}
 */
function NamedBuildingInfoScreen(props) {
    
  const titleP = (<h2 className="named-building-info__title__text">{props.title}</h2>);

  if (props.mirrored) {

    return (
        <div className="named-building-info__container">
            <div className="named-building-info__container__right">
                <img className="named-building-info__image" src={props.image} alt=""/>
            </div>
            <div className="named-building-info__container__left">
                { (props.narrow)
                   ? <div className="named-building-info__title__view--narrow">{titleP}</div>
                   : <div className="named-building-info__title__view">{titleP}</div>}
                <p className="named-building-info__info">{props.info}</p>
            </div>
        </div>);
  }
  else {
    return (
        <div className="named-building-info__container">
            <div className="named-building-info__container__left">
            { (props.narrow)
                   ? <div className="named-building-info__title__view--narrow">{titleP}</div>
                   : <div className="named-building-info__title__view">{titleP}</div>}
                <p className="named-building-info__info">{props.info}</p>
            </div>
            <div className="named-building-info__container__right">
                <img className="named-building-info__image" src={props.image} alt=""/>
            </div>
        </div>);
  }
}

export default NamedBuildingInfoScreen;